export const getFundButtons = ({
  isConnected,
  isUploadEnabled,
  disconnectedAt,
  isPrimaryUser
}) => {
  if (isConnected && !isUploadEnabled) return ["SYNC"];

  if (isConnected && isUploadEnabled && !disconnectedAt)
    return ["MANUAL", "SYNC"];

  if (!isConnected && isUploadEnabled && disconnectedAt)
    return ["MANUAL", "LINK"];

  if (!isConnected && !disconnectedAt && isUploadEnabled)
    return isPrimaryUser ? ["MANUAL"] : ["MANUAL", "LINK"];

  if (!isConnected && !isUploadEnabled) return ["LINK"];

  return [];
};
